import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ManualSubscription } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class ManualSubscriptionsService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getSubscriptions(token: string) {
    return this.http.get<ManualSubscription[]>(`${this.BASE_URL}api/my-rova/notifications/manual/subscriptions?token=${token}`);
  }

  saveSubscription(koad: string, token: string) {
    return this.http.post<ManualSubscription>(
      `${this.BASE_URL}api/my-rova/notifications/manual/subscriptions?token=${token}&koad=${koad}`,
      null
    );
  }

  deleteSubscription(id: number, token: string) {
    return this.http.delete<ManualSubscription>(`${this.BASE_URL}api/my-rova/notifications/manual/subscriptions/${id}?token=${token}`);
  }

  deleteSubscriptions(token: string) {
    return this.http.delete<any>(`${this.BASE_URL}api/my-rova/notifications/manual/subscriptions?token=${token}`);
  }
}
